import { DemographicGenderDto } from '@/core/api/dtos/response/demographicGender/demographicGender'
import { DemographicGender } from '@/core/api/entities/demographicGender'

export class DemographicGenderMapper {
	public static toEntity(dto: DemographicGenderDto): DemographicGender {
		return new DemographicGender(dto)
	}

	public static toDTO(entity: DemographicGender): DemographicGenderDto {
		return entity.key
	}

	public static toEntities(dtos: DemographicGenderDto[]): DemographicGender[] {
		return dtos.map(this.toEntity)
	}
}
